import {  ITerceirizacaoRepository } from "../../repositories/terceirizacao_repository";
import { ICreateArquivoGenericoUseCase } from "../../../presentation/useCases/create/create_arquivo_generico_use_case";

// CreateArquivoGenericoUseCase


export class CreateArquivoGenericoUseCase implements ICreateArquivoGenericoUseCase {
  constructor(private readonly repository: ITerceirizacaoRepository) {}

  async createArquivoGenerico( IdTabela: number | null, NomeArquivo1: string | null, Arquivo1: string | null, NomeArquivo2: string | null, Arquivo2: string | null, NomeArquivo3: string | null, Arquivo3: string | null, Ordem: number | null, TipoTabela: number | null): Promise<void> {
    
    await this.repository.createArquivoGenerico(IdTabela, NomeArquivo1, Arquivo1, NomeArquivo2, Arquivo2, NomeArquivo3, Arquivo3, Ordem, TipoTabela
    );
  }
}
